module.exports = [{
      plugin: require('C:/Users/xioag/code/premiumator/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
